module.exports = __webpack_public_path__ + "static/media/more_vert-24px.4357c0b4.svg";